import * as angular from "angular";
import {IController} from "angular";
import {DashboardModel} from "../../models/dashboard.model";

export class DashboardsTableRowComponent implements IController {

  dashboard: DashboardModel;
  isFavoriteDashboard: boolean;
  isSelected: boolean;
  onSelectDashboard: Function;
  onSetDashboardAsFavorite: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardsTableRow', {
    bindings: {
      dashboard: '<',
      isFavoriteDashboard: '<?',
      isSelected: '<?',
      onSelectDashboard: '&',
      onSetDashboardAsFavorite: '&'
    },
    template: require('./dashboards-table-row.html').default,
    controller: DashboardsTableRowComponent
  });
